import { DropdownField } from '@cian/components';
import * as React from 'react';
import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../../common/state';
import { FDealType } from '../../../../utils/category';
import { changeRoomsInDeal } from '../../../state/advanced/rooms_in_deal';
import { InlineBlock, Row } from '../markup';

export interface IRoomsInDealProps {
  dealType: FDealType;
  roomsInDeal: number;
  onRoomsInDealChanged(value: number): void;
}

export const roomsInDeal: React.StatelessComponent<IRoomsInDealProps> = props => (
  <Row title={`Комнат ${(FDealType.Rent & props.dealType && 'в аренду') || 'на продажу'}`}>
    <InlineBlock>
      <DropdownField
        value={props.roomsInDeal}
        onValueChange={(value: number) => props.onRoomsInDealChanged(value)}
        values={[
          { value: 0, label: 'Неважно' },
          { value: 1, label: '1' },
          { value: 2, label: '2' },
          { value: 3, label: '3' },
          { value: 4, label: '4' },
          { value: 5, label: '5' },
        ]}
      />
    </InlineBlock>
  </Row>
);

// tslint:disable-next-line:no-default-export
export default connect<{ roomsInDeal: number }, { onRoomsInDealChanged(value: number): void }, { dealType: FDealType }>(
  (state: IAppState) => ({
    roomsInDeal: (state.filters.jsonQuery.rooms_for_sale && state.filters.jsonQuery.rooms_for_sale.value.gte) || 0,
  }),
  (dispatch: Dispatch) => ({
    onRoomsInDealChanged: (value: number) => {
      dispatch(changeRoomsInDeal(value));
    },
  }),
)(roomsInDeal);
